import { api } from './client';
import { endpoints } from './endpoints';

/** Fit between students and roles, in both directions. */
export function getRecommendations(limit = 10) {
  return api.get(endpoints.internships.recommendations, { params: { limit } });
}

export function getInternshipMatch(id) {
  return api.get(endpoints.internships.match(id));
}

/** How well the student's CV (the primary one unless `resumeId`) covers a listing. */
export function getResumeMatch(id, resumeId) {
  return api.get(endpoints.internships.resumeMatch(id), {
    params: resumeId ? { resume_id: resumeId } : {},
  });
}

export function getCandidateMatches(internshipId, limit = 20) {
  return api.get(endpoints.companies.internshipCandidateMatches(internshipId), {
    params: { limit },
  });
}
